'use client';

import { createFileRoute } from '@tanstack/react-router';

import { GhgSoldProductGHGPage } from '@/features/ghg/pages/GhgSoldProductGHGPage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/ghg/scope3/sold-products')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('ghg:ghgScope3.soldProductGHG'),
  }),
  component: SoldProductsPage,
});

function SoldProductsPage() {
  return (
    <div className="p-8">
      <div className="mx-auto max-w-7xl space-y-6">
        <GhgSoldProductGHGPage />
      </div>
    </div>
  );
}
